import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/The-last-Gemini-/The-last-Gemini-/node_modules/next/dist/client/app-dir/link.js");
